import * as React from 'react';
import { isWebview } from '../utils';
import { logger } from '../lib/logger';
import { useTimerSwitch } from './useTimerSwitch';
import { TriggerType } from '../components/common/Button/CopyToClipboard';

const log = logger('copytoclipboard');
const isAndroidWebView = isWebview(navigator.userAgent, 'android');

const useCopytoClipboard = (textToCopy: string) => {
  const [isError, setIsError] = React.useState(false);
  const { isOn: isCopied, turnOn } = useTimerSwitch(2000);
  // When your mouse leaves the button, the tooltip disappears
  const [triggerType, setTriggerType] = React.useState<TriggerType>('mouseenter click');

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          turnOn();
          setTriggerType('mouseenter focus');
        })
        .catch(error => {
          if (error instanceof Error && error.name !== 'NotAllowedError') {
            log.exception({ errorType: 'ClipboardError', error });
          }
        });
    } else {
      copyToClipboardFallback();
    }
  };

  const copyToClipboardFallback = () => {
    const dummy = document.createElement('textarea');
    dummy.style.position = 'fixed';
    dummy.style.opacity = '0';
    document.body.appendChild(dummy);
    dummy.value = textToCopy;
    dummy.select();

    const isSuccessful = document.execCommand('copy');
    if (!isSuccessful) {
      setIsError(true);
    } else {
      document.body.removeChild(dummy);
      turnOn();
      setTriggerType('mouseenter focus');
    }
  };

  const handleCopy = () => {
    if (isAndroidWebView) {
      copyToClipboardFallback();
    } else {
      copyToClipboard();
    }
  };

  return { isError, isCopied, triggerType, handleCopy, setTriggerType };
};

export { useCopytoClipboard };
